<template>
  <transition enter-active-class="tw-ease-out tw-duration-300" leave-active-class="tw-ease-in tw-duration-200">
    <div v-show="isOpen" class="tw-fixed tw-bottom-0 tw-inset-x-0 tw-px-4 tw-pb-6 sm:tw-inset-0 sm:tw-p-0 sm:tw-flex sm:tw-items-center sm:tw-justify-center tw-z-80">
      <transition
        enter-active-class="tw-ease-out tw-duration-300"
        enter-class="tw-opacity-0"
        enter-to-class="tw-opacity-100"
        leave-active-class="tw-ease-in tw-duration-200"
        leave-class="tw-opacity-100"
        leave-to-class="tw-opacity-0"
      >
        <div v-show="isOpen" class="tw-fixed tw-inset-0 tw-transition-opacity tw-backdrop-blur tw-backdrop-filter" @click="handleBackgroundClick">
          <div class="tw-absolute tw-inset-0 tw-bg-gray-700 tw-opacity-50"></div>
        </div>
      </transition>

      <transition
        enter-active-class="tw-ease-out tw-duration-300"
        enter-class="tw-opacity-0 tw-translate-y-4 sm:tw-translate-y-0 sm:tw-scale-95"
        enter-to-class="tw-opacity-100 tw-translate-y-0 sm:tw-scale-100"
        leave-active-class="tw-ease-in tw-duration-200"
        leave-class="tw-opacity-100 tw-translate-y-0 tw-sm:tw-scale-100"
        leave-to-class="tw-opacity-0 tw-translate-y-4 sm:tw-translate-y-0 sm:tw-scale-95"
      >
        <div
          v-show="isOpen"
          class="tw-transform tw-transition-all sm:tw-h-full sm:tw-w-full sm:tw-p-6 tw-fixed sm:tw-static tw-inset-0 tw-overflow-hidden tw-flex tw-flex-col-reverse sm:tw-justify-center sm:tw-items-center tw-pointer-events-none"
        >
          <div :class="['tw-overflow-auto tw-pointer-events-auto tw-w-full tw-p-2 sm:tw-p-0', `sm:tw-max-w-${size}`]">
            <slot />
          </div>
        </div>
      </transition>
    </div>
  </transition>
</template>

<script>
export default {
  props: {
    preventCloseOnBackgroundClick: Boolean,
    size: {
      type: String,
      default: "xl",
    },
  },
  data() {
    return {
      isOpen: false,
    };
  },
  methods: {
    show() {
      this.isOpen = true;
    },
    hide() {
      this.isOpen = false;
    },
    handleBackgroundClick() {
      if (!this.preventCloseOnBackgroundClick) {
        this.isOpen = false;
      }
    },
  },
  watch: {
    isOpen(newVal) {
      this.$emit(newVal ? "showing" : "hiding");
    },
  },
};
</script>
